import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class MemoryService {
  accessToken?: string;

  constructor(private storageService: StorageService) {
  }

  private _customerId!: number | null;

  get customerId(): number | null {
    if (!this._customerId) {
      this._customerId = this.storageService.loadCustomerId();
    }

    return this._customerId;
  }

  set customerId(value: number) {
    if (value) {
      this._customerId = value;
      this.storageService.storeCustomerId(value);
    }
  }
}
